import React, { useEffect } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import "../design.css";
import InfoIcon from "../../../shared-components/Info-Icon/InfoIcon";
import { validateHeader } from "../Helpers/Validations";
import { optimizeLogo } from "../../../../utlities/optimize-logo";
import { loadToaster } from "../../../shared-components/toaster/toaster-actions-creators";

const DetailsContent = (props) => {
  const { dataContent, onChange, error, setError } = props;

  useEffect(() => {
    console.log("hey eeror", error);
  }, [error]);

  useEffect(() => {
    if (dataContent) setError(validateHeader(dataContent));
    return () => {};
  }, [dataContent]);
  async function handleLogoChange(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    const isAllowed =
      file &&
      file.type &&
      (file.type === "image/jpeg" || file.type === "image/png");

    if (!isAllowed) {
      loadToaster({
        type: "error",
        title: "Failed to upload Image",
        msg: "Only JPG and PNG files are allowed.",
      });
    }

    try {
      const base64 = await optimizeLogo(file);

      // Use your existing onChange(contract): (e, fieldName, dataContent)
      // We pass a synthetic event that mimics e.target.value
      onChange({ target: { value: base64 } }, "logo", dataContent);

      // clear any previous logo error if you have one in your validateHeader
      setError((prev) => ({ ...prev, logo: "" }));
    } catch (err) {
      // surface a friendly error
      setError((prev) => ({
        ...prev,
        logo:
          err?.message ||
          "Unable to process image. Please upload a JPG or PNG under a few MB.",
      }));
    } finally {
      // reset the input so the same file can be re-selected if needed
      e.target.value = "";
    }
  }

  return (
    <div className="">
      <div className="col-12">
        <div
          className="row"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <div>
            <span
              className="tab-view-label"
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                marginBottom: "3px",
              }}
            >
              Survey Title
              <span
                style={{ fontWeight: 600, color: "#b21dac", paddingLeft: 3 }}
              >
                *
              </span>{" "}
              :{" "}
            </span>
            {error.title && (
              <span className="error-message"> {error.title}</span>
            )}
          </div>
          <InputTextarea
            style={{ fontSize: "normal", marginLeft: "10px", width: "97%" }}
            name="title"
            placeholder="Enter Your Survey Title Here"
            rows={1}
            onChange={(e) => {
              onChange(e, "title", dataContent);
            }}
            value={dataContent?.title}
            autoResize={true}
          />
        </div>
        <div
          className="row mt-3"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <div>
            <span
              className="tab-view-label"
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                marginBottom: "3px",
              }}
            >
              Survey Description
              {/* <span style={{ fontWeight: 600, color: '#b21dac', paddingLeft: 3 }}>*</span> */}
              :{" "}
            </span>
            {/* {error.question && <span className="error-message"> {error.question}</span>} */}
          </div>
          <InputTextarea
            style={{ fontSize: "normal", marginLeft: "10px", width: "97%" }}
            name="title"
            placeholder="Enter Your Survey Description Here"
            rows={1}
            onChange={(e) => {
              onChange(e, "description", dataContent);
            }}
            value={dataContent?.description}
            autoResize={true}
          />
        </div>
        <div
          className="row mt-3"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              // , justifyContent: 'space-between'
            }}
          >
            <span
              className="tab-view-label"
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                marginBottom: "3px",
              }}
            >
              Survey Logo
              {/* <span style={{ fontWeight: 600, color: '#b21dac', paddingLeft: 3 }}>*</span>  */}
              :
            </span>
            {/* <div style={{ display: 'flex', alignItems: 'center', marginLeft: '10px' }}>
                        <InfoIcon msg="You can paste url here" />
                    </div> */}
            {/* {error.logo && <span className="error-message"> {error.logo}</span>} */}
          </div>
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "12px",
   
    }}
  >
          <label
            style={{
              display: "inline-block",
              padding: "6px 12px",
              borderRadius: "6px",
              cursor: "pointer",
              border: "1px solid #ccc",
              width: "max-content",
             
            }}
          >
            <i className="pi pi-upload me-2" style={{ fontSize: "14px" }}></i>
            Upload Logo
            <input
              type="file"
              accept="image/png, image/jpeg"
              style={{ display: "none" }}
              onChange={handleLogoChange}
            />
          </label>

          {/* show file name if available */}
          {dataContent?.logoFileName && (
            <div
              style={{ marginLeft: "10px", marginTop: "5px", fontSize: "12px" }}
            >
              {dataContent.logoFileName}
            </div>
          )}
          {dataContent?.logo ? (
            <div style={{ marginLeft: "10px", marginTop: "10px" }}>
              <img
                src={dataContent.logo}
                alt="Survey Logo Preview"
                style={{
                  height: "50px",
                  width: "auto",
                  maxWidth: "100%",
                  objectFit: "contain",
                  border: "1px dashed #e0e0e0",
                  padding: "3px",
                  borderRadius: "6px",
                }}
              />
            </div>
          ) : null}
        </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsContent;
